import { widgetElement } from "@/app/utils/Utils";
import { STORE } from "@/store";
import { reaction } from "mobx";
import { telemetryTracker } from "./PanelTelemetryTracker";
export class VisibilityChecker {
    constructor() {
        this.checkVisibility = (tag, upd) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            switch (tag) {
                case "SCREEN_POP":
                    return {
                        visible: STORE.session.screenpop.screenPopSelector.length > 0,
                        dispose: reaction(() => STORE.session.screenpop.screenPopSelector, (x) => upd(x.length > 0))
                    };
                case "WXM_JOURNEY":
                    telemetryTracker(widgetElement.WXM_JOURNEY);
                    return {
                        visible: STORE.app.wxmEnabled,
                        dispose: reaction(() => STORE.app.wxmEnabled, (x) => upd(x))
                    };
                case "IVR_TRANSCRIPT":
                    return {
                        visible: !!((_a = this.agentContactProps) === null || _a === void 0 ? void 0 : _a.isDefinedIvrTranscript),
                        dispose: reaction(() => { var _a; return (_a = this.agentContactProps) === null || _a === void 0 ? void 0 : _a.isDefinedIvrTranscript; }, (x) => upd(!!x))
                    };
                case "RT_TRANSCRIPT":
                    return {
                        visible: STORE.app.featureFlags.isRealTimeTranscriptionEnabled,
                        dispose: reaction(() => STORE.app.featureFlags.isRealTimeTranscriptionEnabled, (x) => upd(x))
                    };
                // CallGuide is a third-part widget which requires conditional visibility.
                // In future when dynamic visibility is implemented below condition needs to be updated.
                case "CALL_GUIDE":
                    return {
                        visible: (((_c = (_b = this.agentContactProps) === null || _b === void 0 ? void 0 : _b.getCallGuideProps) === null || _c === void 0 ? void 0 : _c.outboundType) === "CAMPAIGN" &&
                            STORE.agent.agentId === ((_e = (_d = this.agentContactProps) === null || _d === void 0 ? void 0 : _d.getCallGuideProps) === null || _e === void 0 ? void 0 : _e.owner)) ||
                            (STORE.app.featureFlags.isProgressiveCampaignEnabled &&
                                (((_g = (_f = this.agentContactProps) === null || _f === void 0 ? void 0 : _f.getCallGuideProps) === null || _g === void 0 ? void 0 : _g.outboundType) === "PROGRESSIVE_CAMPAIGN" ||
                                    ((_j = (_h = this.agentContactProps) === null || _h === void 0 ? void 0 : _h.getCallGuideProps) === null || _j === void 0 ? void 0 : _j.outboundType) === "CAMPAIGN_PREDICTIVE_OUTDIAL_CUSTOMER" ||
                                    ((_l = (_k = this.agentContactProps) === null || _k === void 0 ? void 0 : _k.getCallGuideProps) === null || _l === void 0 ? void 0 : _l.outboundType) === "CAMPAIGN_OUTDIAL_CUSTOMER")),
                        dispose: reaction(() => { var _a, _b; return (_b = (_a = this.agentContactProps) === null || _a === void 0 ? void 0 : _a.getCallGuideProps) === null || _b === void 0 ? void 0 : _b.outboundType; }, (x) => upd(x === "CAMPAIGN"))
                    };
                case "CUSTOMER_JOURNEY_WIDGET":
                    return {
                        visible: STORE.app.featureFlags.isCJDSEnabled,
                        dispose: reaction(() => STORE.app.featureFlags.isCJDSEnabled, (x) => upd(x))
                    };
                case "CONTACT_HISTORY":
                    return {
                        visible: !STORE.app.featureFlags.isContactHistoryDisabled,
                        dispose: reaction(() => !STORE.app.featureFlags.isContactHistoryDisabled, (x) => upd(x))
                    };
                default: {
                    return { visible: true };
                }
            }
        };
    }
}
